import { Component } from "@angular/core";
import { ICellRendererAngularComp, ITooltipAngularComp } from "ag-grid-angular";
import { Router } from '@angular/router';
// import { GridOptionsWrapper } from 'ag-grid-community';
// import { CommonService } from '../../shared-services/common.service';
import { CommonHelper } from "../../../utilities/common.helper";
import { SharedService } from "../../sharedServices/shared.service";
// import { CommonHelper } from '../../utilities/common.helper';

// @Component({
//   selector: 'child-cell',
//   template: `<div class="grid-button"><button (click)="invokeParentMethod()" class="btn btn-link">Proceed To Task</button></div>`,
//   styles: [
//     ``
//   ]
// })


// export class ChildMessageRenderer implements ICellRendererAngularComp {

//   constructor(private router: Router) { }

//   public params: any;


//   agInit(params: any): void {
//     this.params = params;
//   }

//   public invokeParentMethod() {
//     this.params.context.componentParent.methodFromParent(this.params)
//   }

//   refresh(): boolean {
//     return false;
//   }

// }


@Component({
	selector: 'view-cell',
	template: `
    <div class="grid-button dflex">
      <button class="custom-ag-btn" title="View Student Details" (click)="viewDetails()">
      <i class="das-view" ></i>
      </button>

      <!-- <button class="custom-ag-btn" *ngIf="params?.data?.isActiveApplicant == false " [disabled]="params?.data?.statusId != 401402" title="Active selected Student" (click)="activeDetails()">
      <i class="das-check-icon" ></i>
      </button>

      <button class="custom-ag-btn" *ngIf="params?.data?.isActiveApplicant == true" [disabled]="params?.data?.statusId != 401402" title="Block selected Student" (click)="blockDetails()">
      <i class="das-blocked" ></i>
      </button> -->


       <button class="custom-ag-btn"  title="Approve" [disabled]="(params.data.statusId == 401409||params.data.statusId == 401413 ||params.data.statusId == 401408 || params.data.statusId == 401412)"  (click)="setFPStatusOfStudent(401412)">
      <i class="das-check-icon" ></i>
      </button>

	  <!--  Block hidden/disabled when Blocked by HEC Admin OR Blocked by UFP  -->
     <!-- For Blocked application Approved Action is enabled -->
	  <button class="custom-ag-btn"  title="Block" [disabled]="(params.data.statusId == 401407 || params.data.statusId == 401411)"  (click)="setFPStatusOfStudent(401411)">
      <i class="das-blocked" ></i>
      </button>

      <button class="custom-ag-btn"  title="Reject" [disabled]="(params.data.statusId == 401409 || params.data.statusId ==401413 || params.data.statusId == 401412 || params.data.statusId == 401408 || params.data.statusId == 401411 || params.data.statusId == 401407)"   (click)="setFPStatusOfStudent(401413)">
      <i class="das-delete-icon" ></i>
      </button>
    </div>
  `,
	styles: [``],
	providers: [SharedService],
})
export class adminButtons implements ICellRendererAngularComp {
	public params: any;

	constructor(
	) { }
	agInit(params: any): void {
		this.params = params;
	}

	refresh(): boolean {
		return false;
	}

	setFPStatusOfStudent(statusType) {
		console.log(statusType)
		this.params.context.componentParent.methodFPActiveStatusCoursera(this.params.data, statusType);
	}

	blockDetails() {
		this.params.context.componentParent.methodToblockStudentDetails(this.params.data);
	}

	activeDetails() {
		this.params.context.componentParent.methodToactiveStudentDetails(this.params.data);
	}

	viewDetails() {
		this.params.context.componentParent.methodToviewStudentDetails(this.params.data);
	}

	public downloadDocument() {
	}
}


@Component({
	selector: 'view-cell',
	template: `
    <div class="grid-button dflex">
      <button class="custom-ag-btn" title="View Student Details" (click)="viewStudentDetails()">
      <i class="das-view" ></i>
      </button>

      <button class="custom-ag-btn"  title="Approve" [hidden]="(params.data.statusId == 401408 || params.data.statusId == 401413)"  (click)="setStatusOfStudent(401408)">
      <i class="das-check-icon" ></i>
      </button>

	  <!--  Block hidden/disabled when Blocked by HEC Admin OR Blocked by UFP  -->
      <!-- For Blocked application Approved Action is enabled -->
       <button class="custom-ag-btn"  title="Block" [hidden]="(params.data.statusId == 401407 || params.data.statusId == 401411)" [disabled]="disableBlock()" (click)="setStatusOfStudent(401407)">
      <i class="das-blocked" ></i>
      </button>

      <button class="custom-ag-btn"  title="Reject" [hidden]="(params.data.statusId == 401409 || params.data.statusId == 401408 || params.data.statusId == 401412 || params.data.statusId == 401411 || params.data.statusId == 401407)" [disabled]="disableReject()"  (click)="setStatusOfStudent(401409)">
      <i class="das-delete-icon" ></i>
      </button>
    </div>
  `,
	styles: [``],
	providers: [SharedService],
})
export class hecAdminButtons implements ICellRendererAngularComp {
	public params: any;

	constructor(
	) { }
	agInit(params: any): void {
		console.log(params)
		this.params = params;
	}

	refresh(): boolean {
		return false;
	}


	setStatusOfStudent(statusType) {
		this.params.context.componentParent.methodActiveStatusCoursera(this.params.data, statusType);
	}

	viewStudentDetails() {
		this.params.context.componentParent.methodStudentDetailsCoursera(this.params.data);
	}

	public disableApproved(): boolean {
		return this.params.data.statusId == 401409
	}

	public disableReject(): boolean {
		return (this.params.data.statusId == 401408 || this.params.data.statusId == 401407)
	}

	public disableBlock(): boolean {
		return (this.params.data.statusId == 401409)
	}

	public downloadDocument() {
	}
}



